// data/languages/Cote/categories/verbes.ts

import { CategoryData } from '../../../../types/types';

export const verbes: CategoryData = {
    // Actions quotidiennes (Vérifiées)
    'ⲙⲟⲟϣⲉ (mooshe)': {
        translation: 'Marcher',
        translationEn: 'To walk',
        illustration: '🚶'
    },
    'ⲟⲩⲱⲙ (ouôm)': {
        translation: 'Manger',
        translationEn: 'To eat',
        illustration: '🍽️'
    },
    'ⲉⲛⲕⲟⲧ (enkot)': {
        translation: 'Dormir',
        translationEn: 'To sleep',
        illustration: '😴'
    },
    'ⲥⲱ (sô)': {
        translation: 'Boire',
        translationEn: 'To drink',
        illustration: '🥤'
    },
    'ⲧⲱⲟⲩⲛ (toun)': {
        translation: 'Se lever / S\'éveiller',
        translationEn: 'To get up / To wake up',
        illustration: '🧍'
    },
    'ϩⲉⲙⲥⲓ (hemsi)': {
        translation: 'S\'asseoir',
        translationEn: 'To sit down',
        illustration: '💺'
    },

    // Communication (Vérifiées)
    'ⲥⲁϫⲓ (saji)': {
        translation: 'Parler / Dire',
        translationEn: 'To speak / To say',
        illustration: '🗣️'
    },
    'ⲥⲱⲧⲉⲙ (sôtem)': {
        translation: 'Écouter / Entendre',
        translationEn: 'To listen / To hear',
        illustration: '👂'
    },
    'ⲥϧⲁⲓ (sqai)': {
        translation: 'Écrire',
        translationEn: 'To write',
        illustration: '✍️'
    },

    // Actions de déplacement (Vérifiées)
    'ⲡⲱⲧ (pôt)': {
        translation: 'Courir',
        translationEn: 'To run',
        illustration: '🏃'
    },
    'ⲓ (i)': {
        translation: 'Venir',
        translationEn: 'To come',
        illustration: '👈'
    },
    'ϣⲉ (še)': {
        translation: 'Aller',
        translationEn: 'To go',
        illustration: '👉'
    },

    // Nouveaux Verbes Fondamentaux (Ajoutés et Vérifiés)
    'ⲉⲓⲣⲉ (eire)': {
        translation: 'Faire / Agir',
        translationEn: 'To do / To act',
        illustration: '🛠️'
    },
    'ⲛⲁⲩ (nau)': {
        translation: 'Voir',
        translationEn: 'To see',
        illustration: '👀'
    },
    'ⲥⲟⲟⲩⲛ (sooun)': {
        translation: 'Savoir / Connaître',
        translationEn: 'To know',
        illustration: '🧠'
    },
    'ϯ (ti)': {
        translation: 'Donner',
        translationEn: 'To give',
        illustration: '🎁',
        audio: 'Co-Ti'
    },
    'ϫⲓ (ji)': {
        translation: 'Prendre / Recevoir',
        translationEn: 'To take / To receive',
        illustration: '🖐️'
    },
    'ⲟⲩⲱϣ (ouôš)': {
        translation: 'Vouloir / Désirer',
        translationEn: 'To want / To desire',
        illustration: '✨'
    },
    'ⲙⲉⲣⲉ (mere)': {
        translation: 'Aimer',
        translationEn: 'To love',
        illustration: '❤️'
    },
    'ϣⲱⲡⲓ (shôpi)': {
        translation: 'Être / Devenir',
        translationEn: 'To be / To become',
        illustration: '✨'
    }
};

export default verbes;
